import { useState } from 'react';

interface RecoveryModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    orderDate: string;
    orderValue: string;
}

export default function RecoveryModal({
    isOpen,
    onConfirm,
    onCancel,
    orderDate,
    orderValue,
}: RecoveryModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fade-in">
                <div className="text-center mb-6">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                        <svg
                            className="h-6 w-6 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">
                        Pedido em Aberto Encontrado
                    </h3>
                    <p className="mt-2 text-sm text-gray-500">
                        Identificamos um pedido iniciado em <strong>{orderDate}</strong> no valor de <strong>{orderValue}</strong> que não foi finalizado.
                    </p>
                    <p className="mt-4 text-gray-700 font-medium">
                        Deseja continuar de onde parou?
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                    <button
                        onClick={onCancel}
                        className="w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm"
                    >
                        Não, começar novo
                    </button>
                    <button
                        onClick={onConfirm}
                        className="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
                    >
                        Sim, continuar
                    </button>
                </div>
            </div>
        </div>
    );
}
